// BannerSigupSubsection.jsx
import React from "react";
import Button from "../../../../components/Button/Button";
import "./style.scss";

const BannerSigupSubsection = ({ t,i18n,navigate }) => {
  return (
    <section className="banner">
      <div className="container banner--card">
        <div className="banner__text">
          <h3>{t("Sign up now and get started.")}</h3>
          <p>
            {t(
              "Create your free account today and gain access to all the exclusive features designed just for you."
            )}
          </p>
        </div>
        <div className="banner__cta">
          <Button type="primary" text={t("Get Started")} onClick={()=> navigate(i18n.language === 'fr' ? '/fr/login' : '/login')} />
        </div>
      </div>
    </section>
  );
};

export default BannerSigupSubsection;
